import {
    ElementRef,
    HostBinding,
    Component,
    OnInit,
    ViewChild,
    forwardRef,
    Input,
    Optional,
    Self,
    ChangeDetectorRef,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import {
    NgControl,
    FormControl,
    NG_VALUE_ACCESSOR,
    ControlValueAccessor,
} from '@angular/forms';
import { Subject, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// import { MatAutocompleteSelectedEvent, MatChipInputEvent, MatAutocomplete } from '@angular/material';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FocusMonitor } from '@angular/cdk/a11y';
import { MultiAutoItem } from '../../models/multiautoitem';

@Component({
    selector: 'multiselect-autocomplete',
    templateUrl: 'multi-select-autocomplete.component.html',
    styleUrls: ['multi-select-autocomplete.component.scss'],
    providers: [
        { provide: MatFormFieldControl, useExisting: MultiselectAutocomplete },
    ],
    standalone: false,
})
export class MultiselectAutocomplete
    implements OnInit, OnChanges, MatFormFieldControl<MultiAutoItem>
{
    @ViewChild('inputTrigger', { read: MatAutocompleteTrigger })
    inputTrigger: MatAutocompleteTrigger;
    @Output() onSelectItems = new EventEmitter<any>();
    itemControl = new FormControl();
    stateChanges = new Subject<void>();
    private _placeholder: string;
    static nextId = 0;
    @HostBinding() id = `input-ac-${MultiselectAutocomplete.nextId++}`;
    @HostBinding('attr.aria-describedby') describedBy = '';
    setDescribedByIds(ids: string[]) {
        this.describedBy = ids.join(' ');
    }

    @Input() set value(value: any) {
        if (value) {
            this.selectedItems = value;
        }
        this.stateChanges.next();
    }
    get value() {
        return this.selectedItems;
    }
    @Input()
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(plh) {
        this._placeholder = plh;
        this.stateChanges.next();
    }
    private changeCallback: Function;
    private touchedCallback: Function;
    focused = false;
    isAllSelected = false;

    @Input() items = [];
    @Input() formValue = [];
    selectedItems: MultiAutoItem[] = new Array<MultiAutoItem>();
    filteredItems: MultiAutoItem[];
    selectedFormData: any[] = [];
    // filteredItems: Observable<MultiAutoItem[]>;
    removable: boolean = true;

    constructor(
        @Optional() @Self() public ngControl: NgControl,
        private fm: FocusMonitor,
        private elRef: ElementRef<HTMLElement>,
        private cd: ChangeDetectorRef
    ) {
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
        fm.monitor(elRef.nativeElement, true).subscribe(origin => {
            this.focused = !!origin;
            this.stateChanges.next();
        });
    }
    empty: boolean;
    shouldLabelFloat: boolean;
    required: boolean;
    disabled: boolean;
    errorState: boolean;
    controlType?: string;
    autofilled?: boolean;
    userAriaDescribedBy?: string;
    onContainerClick(event: MouseEvent): void {
        throw new Error('Method not implemented.');
    }

    writeValue(value: any) {
        if (value && value.length === 0) {
            let len = this.filteredItems?.length;
            this.selectedItems = [];
            for (let i = 0; i < len; i++)
                this.filteredItems[i].selected = false;
            for (let i = 0; i < this.items.length; i++)
                this.items[i].selected = false;
        }
    }
    registerOnChange(fn: Function) {
        this.changeCallback = fn;
    }
    registerOnTouched(fn: Function) {
        this.touchedCallback = fn;
    }

    lastFilter = '';

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.hasOwnProperty('items') &&
            (changes.items.previousValue === undefined ||
                changes.items.previousValue?.length === 0)
        ) {
            this.filteredItems = changes.items.currentValue;
            this.setSelectedItems(this.selectedFormData);
        }
        if (changes.hasOwnProperty('formValue')) {
            this.selectedFormData = changes.formValue.currentValue;
            this.setSelectedItems(this.selectedFormData);
        }
    }

    setSelectedItems(selectedData) {
        if (selectedData.length > 0) {
            var result = this.filteredItems.filter(function (e) {
                e.selected = selectedData.indexOf(e.id) != -1 ? true : false;
                return selectedData.indexOf(e.id) != -1;
            });
            this.selectedItems = result;
        }
    }

    ngOnInit() {
        this.itemControl.valueChanges
            .pipe(
                startWith<string | MultiAutoItem[]>(''),
                map(value =>
                    typeof value === 'string' ? value : this.lastFilter
                ),
                map(filter => this.filter(filter))
            )
            .subscribe(data => (this.filteredItems = data));
    }
    clicker() {
        this.inputTrigger.openPanel();
    }
    filter(filter: string): MultiAutoItem[] {
        this.lastFilter = filter;
        if (filter) {
            return this.items.filter(option => {
                return (
                    option.item.toLowerCase().indexOf(filter.toLowerCase()) >= 0
                );
            });
        } else {
            return this.items.slice();
        }
    }
    trackByItem(index: number, item: MultiAutoItem) {
        return item.item; // or a real unique id if you have one
    }

    optionClicked(event: Event, item: MultiAutoItem) {
        event.stopPropagation();
        this.toggleSelection(item);
    }

    toggleSelectAll() {
        this.isAllSelected = !this.isAllSelected;

        this.items.forEach(i => (i.selected = this.isAllSelected));
        this.selectedItems = this.isAllSelected ? [...this.items] : [];

        this.cd.markForCheck();
        this.onSelectItems.emit(this.selectedItems);
    }

    toggleSelection(item: MultiAutoItem) {
        item.selected = !item.selected;

        if (item.selected) {
            this.selectedItems.push(item);
        } else {
            this.isAllSelected = false;
            const i = this.selectedItems.findIndex(v => v.item === item.item);
            if (i > -1) this.selectedItems.splice(i, 1);
        }

        this.onSelectItems.emit(this.selectedItems);
    }

    get commaseparatedSelectedItems() {
        let commaSeparated = '';

        if (this.selectedItems.length) {
            commaSeparated = this.selectedItems[0].item;
        }

        for (let i = 1; i < this.selectedItems.length; i++) {
            commaSeparated += ', ' + this.selectedItems[i].item;
        }

        return commaSeparated;
    }

    ngOnDestroy() {
        this.fm.stopMonitoring(this.elRef.nativeElement);
        this.stateChanges.complete();
    }
}
